import * as React from 'react';
import {
  ChatBubble,
  ChatAnchor,
  ChatContent,
  ChatBody,
  CHAT_BUBBLE_ORIENTATION,
} from '@spaced-out/ui-design-system';
import css from './thinking-widget.css';

//TODO:(diwakersurya) revisit this when backend starts sending the thinking texts
type ThinkingWidgetProps = {
  text: string;
};
export const ThinkingWidget = ({text}: ThinkingWidgetProps) => {
  const effectiveText = text || 'Thinking';
  return (
    <ChatBubble orientation={CHAT_BUBBLE_ORIENTATION.left}>
      <ChatAnchor />
      <ChatContent classNames={{wrapper: css.chatContentWrapper}}>
        <ChatBody isLoading loadingText={effectiveText}></ChatBody>
      </ChatContent>
    </ChatBubble>
  );
};
